<template>
<div class="chapter">
<div class="inner_page">
<p class="paraspaceabovebm"><a id="ch05"></a><a id="page_22"><span class="txit">I had to make her understand. That was how it all started. I had to make her understand what she had done to me. But how could I explain? That at night the pain twisted like a thousand knives in my guts, knives that work their way up through my belly and chest. As if a ravenous predator were eating me up from inside, a massive parasite with razor-sharp teeth and cold, smooth lightning-fast limbs from which it is impossible to free myself</span>.</a></p><a id="page_22">
<p class="indent"><span class="txit">Would I be able to describe the emptiness and the loss? That every sunrise announced that yet another meaningless day was approaching. Meaningless hours filled with equally meaningless activities awaiting nothing. And with every day the distance increased. The distance from Her</span>.</p>
<p class="indent"><span class="txit">Would I be able to explain that my dreams were so intense and real that I wept with disappointment when I woke up, bathed in sweat like in a fever?</span></p>
<p class="indent"><span class="txit">Can you get someone else to understand something like that anyway? And even if I succeeded, what good would it do?</span></p>
<p class="indent"><span class="txit">Really?</span></p>
<p class="imagecm1"><img alt="logo" height="45" src="images/common.jpg" width="60"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch05.vue?787bc6b8